import { GET_FLOWS, SET_FLOWS } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const flowsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FLOWS:
      return { ...state, isLoading: true };
    case SET_FLOWS:
      return {
        ...state,
        list: action.flows,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default flowsReducer;
